import { useState } from "preact/hooks";

export const TIME_RANGE_OPTIONS = ["6h", "12h", "24h", "7d", "30d", "45d"] as const;

export type TimeRange = (typeof TIME_RANGE_OPTIONS)[number];

export function useTimeRange(defaultRange: TimeRange = "24h") {
  const [range, setRange] = useState<TimeRange>(defaultRange);

  return {
    range,
    setRange,
    options: TIME_RANGE_OPTIONS,
  };
}
